import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MobileMenuService } from '../../../../shared/services/mobile-menu.service';
import { mobileMenu } from '../../../../../data/mobile-menu';
import { MobileMenuItem } from '../../../../shared/interfaces/mobile-menu-item';
import { FiberService } from 'src/app/services/fiber.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss']
})
export class MobileMenuComponent implements OnDestroy, OnInit {
    private destroy$: Subject<void> = new Subject();

    isOpen = false;
    links: MobileMenuItem[] = mobileMenu;
    public menuItems: any;
    selectedSubMenuId: number;
    currentUrl: any;
    isLoggedIn: boolean = false;





    constructor(public mobilemenu: MobileMenuService,
        private router: Router,

        ) { }

    ngOnInit(): void {
        this.mobilemenu.isOpen$.pipe(takeUntil(this.destroy$)).subscribe(isOpen => this.isOpen = isOpen);

        this.isLoggedIn =
        localStorage.getItem('isLoggedIn') === 'true' ? true : false;
    this.currentUrl = window.location.pathname.replace('/', '');
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onItemClick(event: any): void {

        if (event.pageURL !== '#') {
            this.currentUrl=event.pageURL
            this.mobilemenu.close();
        }
        else{

            this.router.navigateByUrl(this.router.url);
        }
console.log("currenturl",this.currentUrl);
console.log("pageurl",event.pageURL);


    }

    // menuAction(menu) {
    //     if (menu.id === 114) {
    //         if (this.selectedSubMenuId) this.selectedSubMenuId = undefined;
    //         else this.selectedSubMenuId = menu.id;
    //     } else {
    //         if (menu.pageURL !== '#') {
    //             this.router.navigate(['/' + menu.pageURL]);
    //             this.currentUrl = menu.pageURL;
    //         }
    //     }
    // }
}
